import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useOutletContext } from 'react-router-dom';
//api
import { editGallery, createGallery } from 'api/gallery';
//components
import Input from 'components/backoffice/customInput/index';
import ModalCustom from 'components/backoffice/modals/ModalCustom';
import FooterModal from 'components/backoffice/modals/FooterModal';

const GalleryModal = ({ type, show, setShow, item, onSuccess }) => {
  const [newCategory, setNewCategory] = useState('');
  const [newImage, setNewImage] = useState('');
  const [requiredImage, setRequiredImage] = useState('');
  const { t } = useTranslation(['backoffice']);
  const [loading, setLoading] = useState(false);
  const { setTitle } = useOutletContext()

  useEffect(() => {
    if (show) {
      if (type === 'create') {
        setTitle(t('creategallery'));
      } else {
        setTitle(t('edit', { title: item?.category }));
      }
    }
  }, [show, type, item, setTitle]);

  const validateForm = () => {
    let hasError = false;

    if (!newImage) {
      hasError = true;
      setRequiredImage(t('camporequerido'));
    } else {
      setRequiredImage('');
    }
    return !hasError;
  };

  const handleNewImage = (image) => {
    setNewImage(image);
    if (image) {
      setRequiredImage('');
    }
  };


  const onCreate = async () => {

    const form = new FormData();
    form.append('category', newCategory);
    form.append('image', newImage);

    if (!validateForm()) return;

    const { status } = await createGallery(form);
    if (status === 200 || status === 201) {
      setNewCategory('');
      setNewImage('');
      setShow(false);
      onSuccess();
      toast.success(t('creadocorrectamente'));
    } else {
      toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
    }
  };

  const onUpdate = async () => {

    const formData = new FormData();
    formData.append('category', newCategory);
    formData.append('image', newImage);

    if (!validateForm()) return;

    const { status } = await editGallery(item.id, formData);
    if (status === 200 || status === 201) {
      setNewCategory('')
      setNewImage('')
      setShow(false);
      onSuccess();
      toast.success(t('editadocorrectamente'));
    } else {
      toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
    }
  };

  const handleHide = () => {
    setNewCategory('')
    setNewImage('')
    setShow(false);
    setTitle(t('gallery'))
  }

  const handleSave = async () => {
    setLoading(true);

    if (type === 'create') {
      onCreate();
    } else {
      onUpdate();
    }
    setLoading(false);

  };

  useEffect(() => {
    if (type === 'edit') {
      if (item.image) {
        fetch(item.image)
          .then((response) => response.blob())
          .then((blob) => {
            const name = item.image.split('?')[0].split('/').pop()
            const file = new File([blob], name, { type: `image/${name.split('.')[1]}` });
            setNewImage(file)
          })
          .catch((error) => {
            console.error(`${t('errorgetimage')}:`, error);
          });
      }
      setNewCategory(item?.category);
    }
  }, [item])



  return (
    <ModalCustom
      show={show}
      onHide={handleHide}
      title={t(type === 'create' ? 'creategallery' : 'editgallery')}
      footer={<FooterModal onCancel={handleHide} onSave={handleSave} loading={loading} />}
    >
      <div className="watchlist-input">
        <Input
          placeholder={t('category')}
          value={newCategory}
          label={t('category')}
          onChange={setNewCategory}
          type={'text'}
          className="watchlist-input"
        />
        <Input
          type="file"
          dropFileMsg={t('dropFile')}
          label={t('imagen')}
          placeholder={t('selectImg')}
          accept="image/*"
          value={newImage}
          onChange={handleNewImage}
          className="watchlist-input"
          error={requiredImage}
        />
      </div>
      {newImage && (
        <>
          <h6>{t('currentimage')}</h6>
          <img className="w-100 h-auto" src={URL.createObjectURL(newImage)} />
        </>
      )}
    </ModalCustom>
  );
};

GalleryModal.prototype = {
  type: PropTypes.oneOf(['create', 'edit']).isRequired,
  item: PropTypes.object,
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default GalleryModal;
